import { render } from "./iconAngleRight.svg?vue&type=template&id=771f9cc4"
const script = {}

import exportComponent from "/home/nodejs/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__